export default "__VITE_ASSET__b1c1202f__"